// 导入相应的网络参数校验规则
import RulesModules from './rules'

/**
 * 该函数会返回一组自动生成的校验规则  在vue文件使得内容不会过于冗长
 * @param {module} 可以根据不同的模块选择不同的参数校验规则
 * @param {rules} 传入一个数组选择需要校验的参数
 * @param {otherRules} 特殊处理的校验
 *
 */
export default function addRules (module, rules, otherRules = {}) {
  if (!module) {
    return new Error('[addRules] module为空')
  }
  if (!rules) {
    return new Error('[addRules] 需要校验的字段(rules)为空')
  }

  // 根据模块获取当前的规则表
  let ruleTable
  switch (module) {
    // 由于传感器 网络和规则的上报并不分开  因此这里的rule是一个整合校验表
    case 'rule': {
      ruleTable = RulesModules.NetRules.call(this)
      break
    }
    case 'device_rule': {
      ruleTable = RulesModules.DeviceRule.call(this)
      break
    }
    case 'add': {
      ruleTable = Object.assign(RulesModules.AddRules.apply(this), otherRules)
      break
    }
    default:
      break
  }

  // 去规则表中查找相应的规则进行导入
  const result = {}
  for (let i = 0; i < rules.length; i++) {
    const ruleName = rules[i]
    result[ruleName] = ruleTable[ruleName]
  }
  return result
}
